import { BlocksArcProgress as Blocks } from './Blocks/BlocksArcProgress'
import { PointsArcProgress as Points } from './Points/PointsArcProgress'

export default {
  Blocks,
  Points
}
